import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from './ListItem';
import { formatCardName } from '../../utils/cardName';

/* 결제 정보 display section - used inside Card across:
   ReservationDetail, TransferComplete, TourComplete
   variant: 'default' (service pages), 'admin' (admin detail pages)
   currency: 'KRW' | 'USD' | (그 외 ISO 코드) — totalAmount 옆에 표시할 통화 단위 결정.
              '' (빈 문자열) 전달 시 단위 미표시 (호출자가 totalAmount 안에 통화 포함시킨 경우).
*/
export default function PaymentInfoSection({
  date,
  method,
  amount,
  extraItems,
  totalLabel,
  totalAmount,
  currency = 'KRW',
  variant = 'default',
}) {
  const { t } = useTranslation();
  const isAdmin = variant === 'admin';
  const itemLayout = isAdmin ? 'admin' : 'inline';
  // 어드민은 한국 운영자 전용 → 라벨은 항상 한국어 (브라우저 lang=en 무시)
  const cur = (currency || '').toUpperCase();
  const suppressUnit = currency === ''; // 호출자가 통화를 amount/totalAmount 에 이미 포함시킨 경우
  const _unitSymbol = cur === 'KRW' ? null : (cur === 'USD' ? 'USD' : cur);
  const L = isAdmin ? {
    title: '결제 정보',
    datetime: '결제 일시',
    method: '결제 수단',
    amount: '결제 금액',
    total: totalLabel || '총 결제 금액',
    won: '원',
  } : {
    title: t('common.payment_info_title'),
    datetime: t('common.payment_datetime'),
    method: t('common.payment_method_field'),
    amount: t('common.payment_amount'),
    total: totalLabel || t('common.total_payment_label'),
    won: t('common.won'),
  };
  // KRW: '원' 표기 / 그 외 통화: ISO 코드(USD 등) 표기 / 빈 문자열: 단위 미표시
  const totalUnit = suppressUnit ? '' : (_unitSymbol || L.won);
  return (
    <>
      <h3 className="text-lg font-bold text-mono-900">{L.title}</h3>
      <div className="flex flex-col">
        <ListItem label={L.datetime} value={date} layout={itemLayout} />
        <ListItem label={L.method} value={formatCardName(method)} layout={itemLayout} />
        <ListItem label={L.amount} value={amount} layout={itemLayout} />
        {extraItems && extraItems.map((item, i) => (
          <ListItem key={i} label={item.label} value={item.value} layout={itemLayout} />
        ))}
      </div>
      {totalAmount && (
        <div className="flex items-center justify-between pt-4 mt-4 border-t border-mono-200">
          <span className="text-md font-bold text-mono-900">{L.total}</span>
          <p className="flex items-baseline gap-0.5">
            <span className="text-xl font-bold text-mono-900">{totalAmount}</span>
            <span className="text-md font-normal text-mono-900">{totalUnit}</span>
          </p>
        </div>
      )}
    </>
  );
}
